import { getInnerError, renderLoader } from 'app/lib/utils/adaya/AdayaUtils';
import Button from 'components/shared/app/Button';
import Dialog from "components/shared/app/Dialog";
import Spinner from 'components/shared/app/Spinner';
import Config from 'lib/Config';
import { parse } from 'qs';
import React, { useCallback, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ApiService from 'services/ApiService';
import './style.scss';

const ShopifyCallback = (props) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showReplaceDialog, setShowReplaceDialog] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const user = props.auth.user;

    useEffect(() => {
        setLoading(true);
        try {
            if (user && user.activeAccount) {
                const providers = user.activeAccount.providers;
                const hasStore = providers.filter(p => p.name == 'Shopify' && p.data && p.data.shop).length > 0;
                setShowReplaceDialog(hasStore);
            } else {
                replaceStore();
            }
        } catch (e) {
            setError(getInnerError(e));
        }
        setLoading(false);
    }, []);

    const replaceStore = useCallback(() => {
        try {
            const { code, shop, state, hmac } = parse(location.search, { ignoreQueryPrefix: true });
            const localState = window.localStorage.getItem('shopifyState');
            setShowReplaceDialog(false);

            if (state === localState) {
                window.localStorage.removeItem('shopifyState');
                setLoading(true);
                ApiService.post('/users/provider/shopify', { code, shop, hmac })
                    .then((res) => {
                        const { success, user } = res;
                        if (!success) {
                            throw user;
                        }

                        props.auth.updateUserLocal(user); // Triggers appData updates.
                        setLoading(false);
                        setShowReplaceDialog(false);
                    })
                    .catch((error) => {
                        console.error('Shopify Callback Error:', error);
                        setError('There was an error completing the Shopify store connection. Please try again.');
                    });
            } else {
                setError('Invalid request.');
            }
        } catch (e) {
            throw e;
        }
    }, [location.search]);

    const cancelConnect = () => {
        navigate('/account');
    }

    const renderConfirmReplaceStoreDialog = () => {
        return <Dialog
            open
            title='Replace Shopify Store'
            body={
                <div className="body center">
                    You have an existing Shopify store connected to this account already.<br />
                    Do you want to replace it?<br /><br />
                    <b>Warning:</b> This will cause all Shopify account data to be removed and replaced by the new account, and will take some time to load the new data.
                </div>
            }
            actions={[
                <Button key="replace" className="btn" round filled color="red" onClick={() => replaceStore()}>Replace</Button>,
                <Button key="cancel" className="btn" round color="blue" bgColor="white" onClick={() => cancelConnect()}>Cancel</Button>
            ]}
        />
    }

    const goToAccountButton = () => (
        <>
            <h4 style={{ color: '#fff', margin: '1rem' }}>Thank you for connecting your Shopify account!</h4>
            <Link to="/account">
                <Button round filled color="green">
                    Go To Account
                </Button>
            </Link>
        </>
    );

    const renderError = () => (
        <div className="flex-col-center error">
            <h3>Error</h3>
            <h4 dangerouslySetInnerHTML={{ __html: error }}></h4>
            <p>Please try to connect your Shopify account again from the Account page.</p>
            <Link to="/account">
                <div className="button color-green filled round">Back to Account</div>
            </Link>
        </div>
    );

    return (
        <div className="shopify-callback-page">
            {
                error ? renderError() :

                    loading ? renderLoader('Connecting to Shopify...') :

                        showReplaceDialog ?

                            renderConfirmReplaceStoreDialog() :

                            <div className="flex-col-center" style={{ marginTop: '4rem' }}>
                                {loading ? <Spinner /> : (
                                    <>
                                        <Helmet><title>{Config.SITE_TITLE_PREFIX} - Shopify Connected</title></Helmet>
                                        <h4 style={{ color: '#fff', margin: '1rem' }}>Thank you for connecting your Shopify account!</h4>
                                        <Link to="/mer">
                                            <Button round filled color="green">View Efficiency Ratio</Button>
                                        </Link>
                                    </>
                                )}
                            </div>

            }

            <Helmet>
                <title>{Config.SITE_TITLE_PREFIX} - Connecting Shopify Account</title>
            </Helmet>

        </div>
    );

}

export default ShopifyCallback;